import React, { useCallback, useMemo, useState } from "react";

import Concluded from "features/forgot-password-mi/steps/Concluded";
import Document from "features/forgot-password-mi/steps/Document";
import Password from "features/forgot-password-mi/steps/Password";
import TypeToken from "features/forgot-password-mi/steps/TypeToken";
import ValidationToken from "features/forgot-password-mi/steps/ValidationToken";

import type { ForgotPasswordHeader } from "features/forgot-password-mi/types";

export function useForgotPasswordMi(): {
  buildStep: () => React.ReactNode;
  header: ForgotPasswordHeader;
  step: number;
  steppers: string[];
} {
  const [step, setStep] = useState(1);
  const [userInfo, setUserInfo] = useState<Record<string, any>>({});
  const [contactId, setContactId] = useState<string | null>(null);

  const [steppers] = useState([
    "Seu documento",
    "Envio do token",
    "Validação do token",
    "Cadastro de Senha",
    "Concluído",
  ]);

  const contact = userInfo.contacts?.find(
    (c: any) => c.contactId === userInfo?.validationContactId
  );

  const buildStep = useCallback(() => {
    return (
      {
        1: (
          <Document
            setStep={setStep}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
          />
        ),
        2: (
          <TypeToken
            setStep={setStep}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            setContactId={setContactId}
          />
        ),
        3: (
          <ValidationToken
            setStep={setStep}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            contactId={contactId}
          />
        ),
        4: (
          <Password setStep={setStep} userInfo={userInfo} />
        ),
        5: <Concluded />,
      }[step] || (
        <Document
          setStep={setStep}
          userInfo={userInfo}
          setUserInfo={setUserInfo}
        />
      )
    );
  }, [step, userInfo, setUserInfo, setStep]);

  const header = useMemo((): ForgotPasswordHeader => {
    return (
      {
        1: {
          h1: "Esqueci minha senha",
          h2: "Informe seus dados abaixo para que possamos lhe ajudar!",
        },
        2: {
          h1: "Esqueci minha senha",
          h2: "Informe de que forma deseja receber o código",
        },
        3: {
          h1: "Insira o código",
          h2: `Informe o código enviado em seu ${
            contact?.contactType === "PHONE" ? "telefone" : "email"
          }`,
        },
        4: {
          h1: "Cadastrar nova senha",
          h2: "Lembre de atender os requisitos de segurança",
        },
        5: {
          h1: "Concluído",
          h2: "Sua senha foi alterada com sucesso",
        },
      }[step] || { h1: "", h2: "" }
    );
  }, [step, contact]);

  return {
    step,
    steppers,
    header,
    buildStep,
  };
}
